import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Alert,
  Modal,
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import { client } from '@Utils'
import { useStateValue } from '../../state'

export const NewCourseModal = ({contextPk, show, toggle}) => {
  const [currentState, dispatch] = useStateValue()
  const [coursenum, updateCourseNum] = useState('')
  const [errorText, updateErrorText] = useState(null)

  const handleCourseNumChange = e => {
    updateCourseNum(e.target.value)
  }

  const AddNewCourse = async () => {
    try {
      await client.post(
        "/account/admin_lti13.createContextCourse/-/", {
          context_pk: contextPk,
          coursenum: coursenum,
        })
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Success"
            content="Successfully added new course."
            scheme={Cinnamon.Crisp.SCHEME_BLUE}
            icon={<i className="far fa-thumbs-up fa-3x" />}
          />
        ),
      })
      // Trigger the lower components useEffect hook
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
      toggle(!show)
      updateCourseNum('')
      updateErrorText(null)
    } catch (err) {
      if (err.response.status === 500) {
        console.log('error: ', err.response)
        ButterToast.raise({
          content: (
            <Cinnamon.Crisp
              title={err.response.statusText}
              content={err.response.data.error}
              scheme={Cinnamon.Crisp.SCHEME_RED}
              icon={<i className="far fa-thumbs-down fa-3x" />}
            />
          ),
        })
      } else {
        updateErrorText(err.response.data.error)
      }
    }
  }

  let errorAlert = errorText ? (
    <Alert className="alert-danger">{errorText}</Alert>
  ) : null

  return (
    <Modal show={show} onHide={() => toggle(!show)}>
      <Modal.Header closeButton>
        <Modal.Title>New Course Mapping</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorAlert}
        <FormGroup controlId="contextId">
          <ControlLabel>Coursenum:</ControlLabel>
          <FormControl
            type="text"
            onChange={handleCourseNumChange}
            value={coursenum}
          />
        </FormGroup>
        <div
          className="btn btn-success btn-myed btn-success-myed"
          onClick={() => AddNewCourse()}
        >
          <div className="far fa-plus fa-fw mr-2" /> Link Course
        </div>
      </Modal.Body>
    </Modal>
  )
}

NewCourseModal.propTypes = {
  contextPk: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}
